import { createReducer } from '../../../utilities';
import {
    SUCCESS_FETCH_CALENDAR_BY_LEAGUE
} from "../../../../actions/entities/league";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return { ...data };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_CALENDAR_BY_LEAGUE]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/support/league/calendar.js